var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var {
  View,
  Easing,
} = ReactNative;

var FadingView = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      style : {},
      children : [<View />],
      initialOpacity : 0,
      animDuration : 0,
    }
  },

  getInitialState : function()
  {
    if( this.props.initialOpacity == 0 ) this._fadedOut = true;
    return {
      opacity : new Animated.Value(this.props.initialOpacity),
    }
  },

  _fadedOut : false,
  setFadedOut : function(fadedOut)
  {
    if( fadedOut == this._fadedOut ) return;
    this._fadedOut = fadedOut;
    var thisThing = this;
    if( this._fadedOut )
    {
      Animated.timing(
       thisThing.state.opacity,
       {toValue: 0,
       duration:thisThing.props.animDuration,
       easing: Easing.out(Easing.ease)},
      ).start();
    }
    else
    {
      Animated.timing(
       thisThing.state.opacity,
       {toValue: 1,
       duration:thisThing.props.animDuration,
       easing: Easing.out(Easing.ease)},
      ).start();
    }
  },

  setOpacity : function(opacity)
  {
    this.setState({
      opacity : new Animated.Value(opacity),
    });
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  render: function()
  {
    var {style, children, ...other} = this.props;

    var style = [style, {opacity:this.state.opacity}];

    return <Animated.View style={style} {...other} >
    {children}
    </Animated.View>
  }
});

module.exports = FadingView;



// WEBPACK FOOTER //
// ./src/FadingView.js